/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="79.64"
        height="95.58"
        viewBox="0 0 79.64 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="none"
          stroke="#fff"
          d="M39.82 94.29C4.94 81.76 1.25 55.02 1.25 30.95V15.78c15.6-.47 28.1-5.14 38.57-14.53 10.47 9.39 23 14.06 38.57 14.53v15.21c0 24.07-3.69 50.81-38.57 63.3Z"
          className="icon-stroke icon-base"
          strokeWidth="2.5"
          strokeLinejoin="round"
          strokeLinecap="round"/>
        <path
          fill="#ffb81c"
          d="M39.71 65.57h6.79a1.34 1.34 0 0 0 1.33-1.33 1.13 1.13 0 0 0 0-.26l-3.89-16.9a1 1 0 0 1 0-.24 1.16 1.16 0 0 1 .53-1 8.58 8.58 0 1 0-11.82-2.76 8.69 8.69 0 0 0 2.77 2.76 1.17 1.17 0 0 1 .52 1v.24l-3.9 16.9a1.13 1.13 0 0 0 0 .26 1.33 1.33 0 0 0 1.33 1.33h6.34Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M39.84 29.29a9.32 9.32 0 0 0-4.92 17.24.41.41 0 0 1 .17.34v.09l-3.9 16.88a1.55 1.55 0 0 0 0 .43 2.08 2.08 0 0 0 2.08 2.08H46.5a2.08 2.08 0 0 0 2-2.08 2.81 2.81 0 0 0 0-.41l-3.9-16.92v-.07a.39.39 0 0 1 .18-.35 9.32 9.32 0 0 0-4.93-17.23Zm0 1.5a7.82 7.82 0 0 1 4.17 14.43 1.94 1.94 0 0 0-.88 1.62 2.41 2.41 0 0 0 0 .38l3.9 16.92v.1a.58.58 0 0 1-.58.58H33.22a.58.58 0 0 1-.58-.58v-.11l3.9-16.88a2.81 2.81 0 0 0 0-.41 1.92 1.92 0 0 0-.87-1.61 7.82 7.82 0 0 1 4.12-14.47Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'ShieldWithKeyholeIcon';

export default Icon;
